import React from "react";
import {BrowserRouter, Route} from 'react-router-dom'
import routes from './components/pages/index'
import {APIProvider} from '@vis.gl/react-google-maps';
import {useEffect} from 'react'

function App() {
  
 
  return (
    <BrowserRouter>
      {
        routes.map((data,idx) => (
          <Route exact path={data.path} component={data.component} key={idx}></Route>
        ))
      }
    </BrowserRouter>
  );
}

export default App;
